import React from 'react';
import About from '../components/About';
import Footer from '../components/Footer';


const AboutPage = () => {
  return (
    <>
        <About/>
        <Footer/>
    </>
  )
}

export default AboutPage;